module.exports = __webpack_public_path__ + "img/fuerstenstein.66fab53.jpg";